import { render, staticRenderFns } from "./LetterLogoCenter.vue?vue&type=template&id=bd2fb230&"
import script from "./LetterLogoCenter.vue?vue&type=script&lang=js&"
export * from "./LetterLogoCenter.vue?vue&type=script&lang=js&"
import style0 from "./LetterLogoCenter.vue?vue&type=style&index=0&id=bd2fb230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports